import { createContainer } from 'unstated-next';
import { useState } from 'react';
import { sortDirection, sortType } from '../views/posts/constants';
import {
  sortPosts,
  getFilteredPosts,
  addBadgesForPosts,
} from '../views/posts/utils';

const initialState = {
  posts: null,
  currentSortDirection: sortDirection.ASC,
  currentSortType: sortType.PERFORMANCE,
  filters: [],
};

const usePostsContainer = stateParams => {
  const combinedState = {
    ...initialState,
    ...stateParams,
  };
  const [state, updateState] = useState(combinedState);

  const setPosts = posts => {
    updateState(prevState => {
      const postsWithBadges = addBadgesForPosts(posts);
      const sortedPosts = sortPosts(postsWithBadges);

      return {
        ...prevState,
        initialPosts: postsWithBadges,
        posts: sortedPosts,
      };
    });
  };

  const removeFilter = id => {
    updateState(prevState => {
      const posts = sortPosts(
        prevState.initialPosts,
        prevState.currentSortType,
        prevState.currentSortDirection
      );
      return {
        ...prevState,
        posts,
        filters: prevState.filters.filter(filter => filter.id !== id),
      };
    });
  };

  const applyFilters = filters => {
    updateState(prevState => {
      const posts = getFilteredPosts(prevState.initialPosts, filters);
      return {
        ...prevState,
        filters,
        posts,
      };
    });
  };

  const addFilter = filter => {
    updateState(prevState => {
      const filters = [...prevState.filters, filter];
      const posts = getFilteredPosts(prevState.initialPosts, filters);
      return {
        ...prevState,
        filters,
        posts,
      };
    });
  };

  const clearFilters = () => {
    updateState(prevState => {
      const posts = sortPosts(
        prevState.initialPosts,
        prevState.currentSortType,
        prevState.currentSortDirection
      );
      return { ...prevState, posts, filters: [] };
    });
  };

  const setSortDirection = direction => {
    updateState(prevState => {
      const posts = sortPosts(
        prevState.posts,
        prevState.currentSortType,
        direction
      );
      return {
        ...prevState,
        posts,
        currentSortDirection: direction,
      };
    });
  };

  const setSortType = type => {
    updateState(prevState => {
      const posts = sortPosts(
        prevState.posts,
        type,
        prevState.currentSortDirection
      );
      return {
        ...prevState,
        posts,
        currentSortType: type,
      };
    });
  };

  return {
    state,
    setPosts,
    removeFilter,
    applyFilters,
    addFilter,
    clearFilters,
    setSortDirection,
    setSortType,
  };
};

const PostsContainer = createContainer(usePostsContainer);

export default PostsContainer;
